import React, { useEffect, useState } from "react";
import BrandsPageSideNav from "./BrandsPageSideNav";
import { Filter } from "react-bootstrap-icons";

function SideNavBrands({ brandName }) {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 900);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 900);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="">
      {/* <div
        className="d-flex align-items-center d-lg-none position-fixed opacity-75 m-2"
        style={{ zIndex: "3" }}
      >
        <button
          className="border-0 rounded-3  "
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasFilterNav"
          aria-controls="offcanvasFilterNav"
        >
          <span className="btn btn-mode p-2">
            <Filter className="fs-5" />
          </span>
        </button>
      </div> */}
      {/* Advanced filter responsive toggler END */}

      {/* Navbar START */}
      <nav className="navbar mx-0">
        <div
          className="offcanvas offcanvas-start"
          // data-bs-scroll="true"
          // data-bs-backdrop="false"
          tabIndex="-1"
          id="offcanvasFilterNav"
          // style={{ width: isSmallScreen ? "15rem" : "30rem" }}
        >
          {/* Offcanvas header */}
          <div className="offcanvas-header ps-2">
            <button
              type="button"
              className="btn-close px-0 ms-auto"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <BrandsPageSideNav brandName={brandName} />

          {/* Offcanvas body */}
          {/* <div className="offcanvas-body d-block px-2 px-lg-0">
            <BrandsMenu />
          </div> */}
        </div>
      </nav>
      {/* Navbar END */}
    </div>
  );
}

export default SideNavBrands;
